import React, { useEffect, useState } from 'react';
import TourPackageServices from '../../../services/externalServices/tourPackages/TourPackageServices';
// import IconComponent from '../../../../../components/IconComponent';
// import { getTheme } from '../../../../../constants/ui';
// import images from '../../../../../themes/images';
import selectedPin from '../../../assets/imgs/icons/selectedPin.jpg'

const CruzeTypes = ({ capacity, onSelect,isAutoBid }) => {
    // const isDarkMode = getTheme().isDarkMode;
    // const themeClass = isDarkMode ? "bg-gray-900 text-white" : "bg-white text-gray-900";

    const [cruzesRaw, setCruzesRaw] = useState([]);
    const [filteredCruzes, setFilteredCruzes] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        const timer = setTimeout(() => {
            fetchCruzeTypes();
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    const fetchCruzeTypes = async () => {
        try {
            setIsLoading(true);
            const response = await TourPackageServices.OnlineCruzeTypes({ serviceAssociated: "TourPackage",  isAutoBid });
            console.log("online drivers",response)
            if (response) {
                setCruzesRaw(response.availableCruze);
                const allIds = response.availableCruze.map((cruze) => cruze._id);
                setSelectedItems(allIds);
                onSelect(allIds);
            }
        } catch (error) {
            console.error('Error fetching Cruze Types:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const updatedCruzes = cruzesRaw
            ?.filter((cruze) => cruze.isEnabled && cruze.seatingCapacity >= capacity)
            .sort((a, b) => a.priority - b.priority) || [];
        
        setFilteredCruzes(updatedCruzes);
        const allIds = updatedCruzes.map((cruze) => cruze._id);
        setSelectedItems(allIds);
        onSelect(allIds);
    }, [capacity, cruzesRaw]);

    const handleSelect = (item) => {
        const isSelected = selectedItems.includes(item._id);
        const updatedSelection = isSelected
            ? selectedItems.filter((id) => id !== item._id)
            : [...selectedItems, item._id];
        setSelectedItems(updatedSelection);
        onSelect(updatedSelection);
    };

    return (
        <div className='p-5'>
            <h3 className="text-sm font-bold">Possible Cruze You Get</h3>
            <p className="text-xs">Choose only the vehicles you want bids from</p>

            {isLoading ? (
                <p className="text-center text-sm">Loading...</p>
            ) : (
                filteredCruzes.length > 0 ? (
                    <div className="flex overflow-x-auto space-x-4 py-4">
                        {filteredCruzes.map((item) => (
                            <button key={item._id} 
                                className={`relative flex flex-col items-center p-2 border rounded-lg transition-all duration-300 ${selectedItems.includes(item._id) ? 'border-green-500' : 'border-gray-300'}`} 
                                onClick={() => handleSelect(item)}>
                                <img src={item.thumbnailImage } alt="Cruze" 
                                    className="w-16 h-12 object-contain" />
                                {selectedItems.includes(item._id) && (
                                    <img src={selectedPin} alt="Selected" className="w-6 h-6 absolute top-2 left-1" />
                                )}
                                <div className="text-center mt-2">
                                    <p className="text-xs font-medium">{item.cruzeName}</p>
                                    {item.seatingCapacity && <p className="text-xs">{item.seatingCapacity}+1 Seater</p>}
                                </div>
                            </button>
                        ))}
                    </div>
                ) : (
                    <div className="text-center mt-3 text-sm">
                        <p>There are no drivers online at this moment for the selected criteria.</p>
                        {/* <IconComponent iconSet="MaterialCommunityIcons" iconName="car-off" iconSize={40} /> */}
                    </div>
                )
            )}
        </div>
    );
};

export default React.memo(CruzeTypes);
